module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 发货单管理")]), _vm._v(" "), _c('div', {
    staticClass: "monewt",
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "wj_flex"
  }, [_c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "138px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "输入客户VIP号查询"
    },
    on: {
      "input": _vm.vipCodeBlur
    },
    model: {
      value: (_vm.vipCode),
      callback: function($$v) {
        _vm.vipCode = $$v
      },
      expression: "vipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "发货编号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "输入发货编号查询"
    },
    on: {
      "input": _vm.sendNoBlur
    },
    model: {
      value: (_vm.sendNo),
      callback: function($$v) {
        _vm.sendNo = $$v
      },
      expression: "sendNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "出库时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "220px",
      "padding-right": "6px"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "clearable": "",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.chukuTime)
      }
    },
    model: {
      value: (_vm.chukuTime),
      callback: function($$v) {
        _vm.chukuTime = $$v
      },
      expression: "chukuTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('span', [_vm._v("签收状态：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getStoreList('1')
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("批次：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.batchNum),
      callback: function($$v) {
        _vm.batchNum = $$v
      },
      expression: "batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1), _vm._v(" "), _c('span', [_vm._v("派送点：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.deliverAddress),
      callback: function($$v) {
        _vm.deliverAddress = $$v
      },
      expression: "deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStoreList('1')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("\n        批量导出Excel\n      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货编号",
      "prop": "sendNo",
      "min-width": "220px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.sendNo) + "\n         \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单生成时间",
      "prop": "sendTime",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "prop": "orderCount",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实收费用 CAD",
      "prop": "amount",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "width": "120px",
      "align": "center",
      "prop": "userBalance"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "remark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出库时间",
      "prop": "createTime",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onLook(scope.row)
            }
          }
        }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onTOEcexlce(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("导出")])])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "840px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单名",
      "prop": "productName",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积 CBM",
      "prop": "productSize",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量 KG",
      "prop": "productWeight",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣率 %",
      "prop": "rate",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.rate !== true) ? _c('span', [_vm._v(_vm._s(scope.row.rate))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用 CAD",
      "prop": "predictTotal",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "prop": "userBalance",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单备注",
      "prop": "remark",
      "min-width": "220px",
      "align": "center"
    }
  })], 1), _vm._v(" "), (_vm.lookingStatus !== 4 && _vm.lookingStatus < 11 && _vm.isCouldUpdated) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "33px",
      "top": "-46px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateExtraFee
    }
  }, [_vm._v("修改额外费用")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isUpdateFeeShow,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isUpdateFeeShow = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("额外费用 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px",
      "margin": "-8px 0 20px 20px"
    },
    attrs: {
      "placeholder": "请输入修改后的费用",
      "autofocus": ""
    },
    model: {
      value: (_vm.feeInput),
      callback: function($$v) {
        _vm.feeInput = $$v
      },
      expression: "feeInput"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "clear": "both",
      "float": "left",
      "padding-bottom": "10px",
      "font-size": "18px"
    }
  }, [_vm._v("\n        备注 :\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容",
      "maxlength": "300",
      "show-word-limit": "",
      "clearable": "",
      "resize": "none",
      "rows": "8"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpdateDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.certainUpdateDialog
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5023eee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/dispatchList.vue
// module id = 1263
// module chunks = 2